// Returns true if element is in viewport
var isElementVisible = function (ele) {
    if (!ele) {
        return false;
    }
    var _a = ele.getBoundingClientRect(), top = _a.top, bottom = _a.bottom;
    var vHeight = window.innerHeight || document.documentElement.clientHeight;
    return (top >= 0 || bottom > 0) && top < vHeight;
};

export { isElementVisible };
